var colorCodes = {
  10100: "#FFFFFF",
  10101: "#000000",
  10102: "#A6A9AA",
  10103: "#8E9089",
  10104: "#D1D3D5",
  10105: "#545454",
  10106: "#F4F4F4",
  10200: "#C12E1F",
  10201: "#F7E6DE",
  10202: "#EC008C",
  10203: "#F55A74",
  10204: "#F5547C",
  10205: "#9D2235",
  10300: "#FF6A13",
  10301: "#FF9016",
  10400: "#F4EE2A",
  10401: "#E4BD68",
  10402: "#FEC600",
  10500: "#164B35",
  10501: "#00AE42",
  10502: "#3F8E43",
  10503: "#BECF00",
  10601: "#0A2989",
  10602: "#5B6579",
  10603: "#0086D6",
  10604: "#0056B8",
  10605: "#00B1B7",
  10700: "#5E43B7",
  10701: "#482960",
  10800: "#9D432C",
  10801: "#847D48",
  10802: "#6F5034",
  10900: "#9CDBD9;#FFFFFF",
  10901: "#E94B3C;#FFFFFF",
  10902: "#307FE2;#54FF9B",
  10903: "#F78F77;#E4505A",
  10904: "#B6FF43;#4EC939",
  10905: "#6FCAEF;#8573DD",
  10906: "#CE4406",
  10907: "#E7C1D5;#8EC9E9",
  11100: "#FFFFFF",
  11101: "#000000",
  11102: "#9B9EA0",
  11103: "#CBC6B8",
  11104: "#757575",
  11200: "#DE4343",
  11201: "#E8AFCF",
  11202: "#BB3D43",
  11203: "#B15533",
  11204: "#950051",
  11300: "#F99963",
  11400: "#F7D959",
  11401: "#E8DBB7",
  11500: "#61C680",
  11501: "#68724D",
  11502: "#C2E189",
  11600: "#0078BF",
  11601: "#A3D8E1",
  11602: "#042F56",
  11603: "#56B7E6",
  11700: "#AE96D4",
  11800: "#D3B7A7",
  11801: "#7D6556",
  11802: "#4D3324",
  11803: "#AE835B",
  12100: "#F9F7F4",
  12101: "#25282A",
  12102: "#515A6C",
  12103: "#898D8D",
  12104: "#000000",
  12105: "#AFB1AE",
  12106: "#959698",
  12107: "#FFFFFF",
  12200: "#DD3C22",
  12300: "#FF7F41",
  12301: "#DC3A27",
  12400: "#FEDB00",
  12401: "#F4D53F",
  12500: "#00482B",
  12600: "#0085AD",
  12601: "#009BD8",
  12700: "#6667AB",
  13100: "#43403D",
  13101: "#2D2B28",
  13102: "#8E9089",
  13103: "#F7F3F0",
  13104: "#EAECEB",
  13105: "#FFFFFF",
  13106: "#D6CCA3",
  13107: "#4F3F24",
  13108: "#5F6367",
  13109: "#C8C8C8",
  13110: "#FFFFFF",
  13200: "#792B36",
  13201: "#AD4E38",
  13202: "#EEB1C1",
  13203: "#684A43",
  13204: "#4C241C",
  13205: "#D02727",
  13206: "#BA9594",
  13207: "#F7ADA6",
  13210: "#B50011",
  13211: "#F5B6CD",
  13300: "#5E4B3C",
  13301: "#F74E02",
  13400: "#B39B84",
  13401: "#E5B03D",
  13402: "#CEA629",
  13403: "#C98935",
  13404: "#F3CFB2",
  13405: "#F4A925",
  13410: "#F5DBAB",
  13500: "#1D7C6A",
  13501: "#3F5443",
  13502: "#4CE4A0",
  13503: "#3B665E",
  13504: "#424379",
  13505: "#918669",
  13506: "#018814",
  13507: "#96DCB9",
  13510: "#96D8AF",
  13600: "#39699E",
  13601: "#147BD1",
  13602: "#594177",
  13603: "#A8C6EE",
  13604: "#008BDA",
  13610: "#B8CDE9",
  13611: "#0047BB",
  13612: "#009FA1",
  13700: "#483D8B",
  13701: "#854CE4",
  13702: "#8671CB",
  13710: "#8344B0",
  13711: "#B8ACD6",
  13800: "#AA6443",
  13801: "#995F11",
  13900: "#373A36;#EEDC00",
  13901: "#FF9425;#C16784",
  13902: "#0047BB;#7D1B49",
  13903: "#0047BB;#BB22A3",
  13904: "#418FDE;#70C884",
  13905: "#000000;#A34342",
  13906: "#F772A4",
  13907: "#0064B3",
  13908: "#DA4C36",
  13909: "#7F3696",
  13910: "#AFDCB9",
  13911: "#E4BEC5",
  13912: "#EC984C",
  14100: "#000000",
  14101: "#4d5054",
  14102: "#FFFFFF",
  14103: "#000000",
  14104: "#CDCECA",
  14200: "#951e23",
  14500: "#5c9748",
  14600: "#6e88bc",
  14601: "#2842AD",
  14700: "#69398E",
  15100: "#FFFFFF",
  15200: "#F17B8F",
  15300: "#FF9D5B",
  15400: "#F8FF80",
  15500: "#A1FFAC",
  15501: "#699F6B",
  15502: "#83F39A",
  15600: "#7AC0E9",
  15700: "#D189EB",
  15701: "#BA8FFB",
  16100: "#000000",
  16101: "#999D9D",
  16103: "#FFFFFF",
  16200: "#C6001A",
  16300: "#F66601",
  16400: "#EFE255",
  16500: "#00B14C",
  16600: "#4DAFDA",
  30100: "#FFFFFF",
  30101: "#000000",
  30102: "#9EA2A2",
  30103: "transparent",
  30104: "#F9F7F2",
  30200: "#D6001C",
  30300: "#FF671F",
  30400: "#FCE300",
  30401: "#B28B33",
  30500: "#009639",
  30501: "#7CD82B",
  30600: "#001489",
  30601: "#688197",
  30602: "#0069B1",
  30700: "#9E007E",
  31100: "#000000",
  31101: "#565656",
  31200: "#9f332a",
  31500: "#16b08e",
  31600: "#324585",
  31700: "#583061",
  32100: "#8E8E8E",
  32101: "#FFFFFF",
  32200: "#F9C1BD",
  32300: "#FF911A",
  32500: "#748C45",
  32501: "#77EDD7",
  32600: "#61B0FF",
  32700: "#D6ABFF",
  32800: "#C9A381",
  33100: "#FFFFFF",
  33101: "#ADB1B2",
  33102: "#000000",
  33103: "#515151",
  33200: "#BC0900",
  33300: "#F75403",
  33400: "#FFD00B",
  33401: "#F9DFB9",
  33500: "#00AE42",
  33501: "#6EE53C",
  33502: "#39541A",
  33600: "#002E96",
  33601: "#1F79E5",
  33801: "#875718",
  40100: "#FFFFFF",
  40101: "#000000",
  40102: "#87909A",
  40200: "#D32941",
  40300: "#FF6A13",
  40400: "#FCE900",
  40401: "#DFD1A7",
  40402: "#FFC72C",
  40500: "#00AE42",
  40501: "#7AE1BF",
  40502: "#789D4A",
  40600: "#0A2CA5",
  40601: "#489FDF",
  40602: "#0C2340",
  40700: "#AF1685",
  40701: "#7248BD",
  41100: "#FFFFFF",
  41101: "#000000",
  41102: "#C6C6C6",
  41200: "#E83100",
  41300: "#F48438",
  41400: "#FFE133",
  41500: "#61BF36",
  41600: "#0C3B95",
  45100: "#FFFAF2",
  45101: "#000000",
  45102: "#8A949E",
  45200: "#E02928",
  45500: "#00A6A0",
  45600: "#2140B4",
  46100: "#F5F1DD",
  46101: "#000000",
  50100: "#FFFFFF",
  50101: "#000000",
  51100: "#101820",
  51101: "#898D8D",
  51102: "#FFFFFF",
  51103: "#000000",
  51104: "#FFFFFF",
  51105: "#FFFFFF",
  51200: "#C8102E",
  51300: "#F68B1B",
  51305: "#F68B1B",
  51400: "#F3E600",
  51500: "#C3E2D6",
  51600: "#0072CE",
  51900: "#40B6E4;#FFFFFF",
  51901: "#F1AAA8;#D21B3C",
  53100: "#FFFFFF",
  53101: "#000000",
  53102: "#939393",
  53200: "#ED0000",
  53300: "#FF9016",
  53400: "#F9EF41",
  53500: "#90FF1A",
  53600: "#5898DD",
  53700: "#975EC9",
  60100: "#FFFFFF",
  60101: "#686865",
  60102: "#000000",
  60103: "transparent",
  63100: "#000000",
  63101: "#FFFFFF",
  63102: "#A8A8AA",
  65100: "#FFFFFF",
  65101: "#000000",
  65102: "#FFFFFF",
  65103: "#000000",
  65104: "#FFFFFF",
  65500: "#C0DF16",
  66100: "#FFFFFF",
  66400: "#F0F1A8",
  70100: "#000000",
  71100: "#000000",
  72100: "#000000",
  72102: "#EAEAE4",
  72103: "#353533",
  72104: "#000000",
  72200: "#FF4800",
  72400: "#FFCE00",
  72500: "#C5ED48",
  72600: "#75AED8",
  72800: "#5B492F",
  73100: "#000000",
  76100: "#000000",
};
var CommonText = {
  filament_with_spool: {
    en: "Filament with spool",
    de: "Filament mit Spule",
    fr: "Filament avec bobine",
    es: "Filamento con carrete",
    it: "Filamento con bobina",
    nl: "Filament met spoel",
    ja: "スプール付き",
  },
  with_spool: {
    en: "With spool",
    de: "Mit Spule",
    fr: "Avec bobine",
    es: "Con carrete",
    it: "Con bobina",
    nl: "Met spoel",
    ja: "スプール付き",
  },
  refill: {
    en: "Refill",
    de: "Nachfüllung",
    fr: "Recharge",
    es: "Rellenar",
    it: "Ricarica",
    nl: "Bijvullen",
    ja: "スプール無し",
  },
  color: {
    en: "Color",
    de: "Farbe",
    fr: "Couleur",
    es: "Color",
    it: "Colore",
    nl: "Kleur",
    ja: "色",
  },
  add: {
    en: "Add",
    de: "Hinzufügen",
    fr: "Ajouter",
    es: "Añadir",
    it: "Aggiungi",
    nl: "Toevoegen",
    ja: "追加",
  },
  show_more: {
    en: "Show more",
    de: "Mehr anzeigen",
    fr: "Afficher plus",
    es: "Mostrar más",
    it: "Mostra di più",
    nl: "Meer tonen",
    ja: "もっと見る",
  },
  hide: {
    en: "Hide",
    de: "Verbergen",
    fr: "Cacher",
    es: "Ocultar",
    it: "Nascondere",
    nl: "Verbergen",
    ja: "閉じる",
  },
  select_items: {
    en: "Select Items",
    de: "Elemente auswählen",
    fr: "Sélectionner des éléments",
    es: "Seleccionar elementos",
    it: "Seleziona elementi",
    nl: "Selecteer items",
    ja: "アイテムを選択",
  },
  items_selected: {
    en: " item(s) selected",
    de: " Element(e) ausgewählt",
    fr: " élément(s) sélectionné(s)",
    es: " artículo(s) seleccionado(s)",
    it: " elemento/i selezionato/i",
    nl: " item(s) geselecteerd",
    ja: " アイテム選択されました",
  },
  packs_selected: {
    en: " pack(s) selected",
    de: " Packung(en) ausgewählt",
    fr: " pack(s) sélectionné(s)",
    es: " paquete(s) seleccionado(s)",
    it: " pacchetto/i selezionato/i",
    nl: " pakket(ten) geselecteerd",
    ja: " パック選択されました",
  },
  close: {
    en: "Close",
    de: "Schließen",
    fr: "Fermer",
    es: "Cerrar",
    it: "Chiudi",
    nl: "Sluiten",
    ja: "閉じる",
  },
  add_one_more: {
    en: "Add one more",
    de: "Einen weiteren hinzufügen",
    fr: "Ajouter un autre",
    es: "Añadir uno más",
    it: "Aggiungi un altro",
    nl: "Voeg een ander toe",
    ja: "さらに追加",
  },
  Product: {
    en: "Product",
    de: "Produkt",
    fr: "Produit",
    es: "Producto",
    it: "Prodotto",
    nl: "Product",
    ja: "商品",
  },
  tpu_90a: {
    en: "TPU 90A",
    de: "TPU 90A",
    fr: "TPU 90A",
    es: "TPU 90A",
    it: "TPU 90A",
    nl: "TPU 90A",
    ja: "TPU 90A",
  },
  tpu_85a: {
    en: "TPU 85A",
    de: "TPU 85A",
    fr: "TPU 85A",
    es: "TPU 85A",
    it: "TPU 85A",
    nl: "TPU 85A",
    ja: "TPU 85A",
  },
};

function getTextByLocale(key) {
  const locale = window.Shopify.locale;
  return CommonText[key][locale] || CommonText[key]["en"];
}

class RecommendProducts {
  constructor(products, limit = 6) {
    this.products = products;
    this.dom = document.getElementById("product_recommend_v2");
    this.limit = limit;
    this.showMore = false;
    // all selected info
    this.selectQuene = [];
    // each active selected info
    this.activeQuene = [];
  }
  init() {
    const root = document.createElement("div");
    root.classList.add("recommend-products-root");
    this.products.forEach((product, index) => {
      const item = this.render(product, index);
      root.appendChild(item);
    });
    const showMoreDom = this.genShowMore();
    if (showMoreDom) {
      root.appendChild(showMoreDom);
    }
    this.dom.appendChild(root);
  }
  reset() {
    this.selectQuene = [];
    this.activeQuene = [];
    this.dom.removeChild(this.dom.lastChild);
    this.init();
  }
  render(product, index) {
    let dom = null;
    switch (product.type) {
      case "starter_pack":
        dom = this.renderStarterPack(product, index);
        break;
      case "filaments":
        dom = this.renderFilaments(product, index);
        break;
      case "filaments_tpu":
        dom = this.renderFilaments(product, index);
        break;
      default:
        dom = this.renderNormal(product, index);
        break;
    }
    return dom;
  }
  renderStarterPack(product, index) {
    const { title, handle, variants } = product;
    const firstVariant = variants.find((variant) => variant.available);
    // create item
    const item = document.createElement("div");
    item.classList.add("rpv2-item");
    item.classList.add("rpv2-item-bundle");
    if (index >= this.limit) {
      item.classList.add("hide");
    }
    item.setAttribute("data-index", index);
    item.innerHTML = `
      <input type="checkbox" class="rpv2-item__checkbox" disabled>
      <img class="rpv2-item__image" src="${product.featured_image}" />
      <div class="rpv2-item__content">
        <div class="rpv2-item__titleWrap">
          <div class="rpv2-item__title">
            <a href="/products/${handle}" target="_blank">${title}</a>
          </div>
        </div>
        <div class="rpv2-item__priceWrap">
          <div class="rpv2-item__price"></div>
        </div>
        <div class="rpv2-item__whatInThePack">
          <span>${product.witb}</span>
        </div>
        <div class="rpv2-item__content__btnWrap">
          <button class="rpv2-item__content__btnWrap__selectBtn">${getTextByLocale(
            "select_items"
          )}</button>
        </div>
        <div class="rpv2-item__content__selectedItemWrap">
          <div class="selectedItem-title">
            <div class="selectedItem-title-inner">
              <span>1</span>
              <span>${getTextByLocale("packs_selected")}</span>
            </div>
          </div>
          <div class="selectedItem-content"></div>
        </div>
      </div>
    `;
    const priceDom = item.querySelector(".rpv2-item__price");
    if (product.price_varies) {
      priceDom.innerHTML = product.discount_from_price;
    } else {
      priceDom.innerHTML = product.discount_price;
    }
    // init activeQuene
    this.activeQuene[index] = {
      productId: product.id,
      id: firstVariant.id,
      quantity: 1,
      title: firstVariant.title,
      options: firstVariant.options,
      price: firstVariant.price,
      discountPrice: firstVariant.discount_price,
    };
    // add events
    this.bundleAddEvent(item, product, index);
    return item;
  }
  renderFilaments(product, index) {
    const { title, handle, variants } = product;

    let spoolList = [];
    let refillList = [];

    if (product.type === "filaments_tpu") {
      spoolList = variants.filter(
        (variant) => variant.option2 === getTextByLocale("tpu_90a")
      );
      refillList = variants.filter(
        (variant) => variant.option2 === getTextByLocale("tpu_85a")
      );
    } else {
      spoolList = variants.filter(
        (variant) => variant.option2 === getTextByLocale("filament_with_spool")
      );
      refillList = variants.filter(
        (variant) => variant.option2 === getTextByLocale("refill")
      );
    }

    let firstVariant = null;
    if (spoolList.length > 0) {
      firstVariant = spoolList[0];
    } else {
      firstVariant = refillList[0];
    }
    console.log(product, firstVariant);
    // create item
    const item = document.createElement("div");
    item.classList.add("rpv2-item");
    item.classList.add("rpv2-item-filaments");
    if (index >= this.limit) {
      item.classList.add("hide");
    }
    item.setAttribute("data-index", index);
    item.innerHTML = `
      <input type="checkbox" class="rpv2-item__checkbox" disabled>
      <img class="rpv2-item__image" src="${firstVariant.featured_image}" />
      <div class="rpv2-item__content">
        <div class="rpv2-item__titleWrap">
          <div class="rpv2-item__title">
            <a href="/products/${handle}?variant=${
      firstVariant.id
    }" target="_blank">${title}</a>
          </div>
          <div class="rpv2-item__discountPrecent"></div>
        </div>
        <div class="rpv2-item__priceWrap">
          <div class="rpv2-item__price"></div>
          <div class="rpv2-item__discountPrice"></div>
          <div class="rpv2-item__weight">${firstVariant.option3}</div>
        </div>
        <div class="rpv2-item__whatInThePack-normal" style="${
          product.witb ? "" : "display:none"
        }">
          <span>${product.witb}</span>
        </div>
        <div class="rpv2-item__filamentTab"></div>
        <div class="rpv2-item__content_selectAndBtnWrap">
            <div class="rpv2-item__content__selectWrap">
            <div class="rpv2-item__content__selectWrap__select" tabindex="-1">
              <div class="rpv2-item__content__selectWrap__select__item">
                <div class="rpv2-item__content__selectWrap__select__item__filamentBox" style="background: ${this.getColor(
                  firstVariant.option1
                )};"></div>
                <div class="rpv2-item__content__selectWrap__select__item__text">${
                  firstVariant.option1
                }</div>
                <div class="rpv2-item__content__selectWrap__select__item__arrow">
                  <svg class="Icon Icon--select-arrow " role="presentation" viewBox="0 0 19 12">
                    <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
                  </svg>
                </div>
              </div>
            </div>
            <ul class="rpv2-item__content__selectWrap__select__ul"></ul>
          </div>
          <div class="rpv2-item__content__btnWrap">
            <div class="rpv2-item__content__btnWrap__QuantityWrap">
              <button class="rpv2-item__content__btnWrap__QuantityWrap__icon">
                <svg class="Icon Icon--custom-minus" role="presentation" width="0.8em" height="0.2em" viewBox="0 0 8 2" fill="none">
                  <path d="M0 1H4H8" stroke="#333333"></path>
                </svg>
              </button>
              <input type="number" class="rpv2-item__content__btnWrap__QuantityWrap__input" name="quantity" value="1" />
              <button class="rpv2-item__content__btnWrap__QuantityWrap__icon">
                <svg class="Icon Icon--custom-plus " role="presentation" width="0.8em" height="0.8em" viewBox="0 0 8 8" fill="none">
                  <path d="M0 4H4H8" stroke="#333333"></path>
                  <path d="M4 0L4 4L4 8" stroke="#333333"></path>
                </svg>
              </button>
            </div>
            <button class="rpv2-item__content__btnWrap__addBtn">${getTextByLocale(
              "add"
            )}</button>
          </div>
        </div>
        <div class="rpv2-item__content__selectedItemWrap">
          <div class="selectedItem-title">
            <div class="selectedItem-title-inner">
              <span>1</span>
              <span>${getTextByLocale("items_selected")}</span>
            </div>
          </div>
          <div class="selectedItem-content"></div>
        </div>
      </div>
    `;
    const discountPrecentDom = item.querySelector(
      ".rpv2-item__discountPrecent"
    );
    const discountPriceDom = item.querySelector(".rpv2-item__discountPrice");
    const priceDom = item.querySelector(".rpv2-item__price");
    if (
      firstVariant.discount_price &&
      firstVariant.discount_price_num !== firstVariant.price_num
    ) {
      discountPrecentDom.innerHTML = this.getDiscountPrecent(
        firstVariant.price_num,
        firstVariant.discount_price_num
      );
      priceDom.innerHTML = firstVariant.discount_price;
      discountPriceDom.innerHTML = firstVariant.price;
    } else {
      discountPrecentDom.innerHTML = "";
      priceDom.innerHTML = firstVariant.price;
      discountPriceDom.innerHTML = "";
    }
    // init activeQuene
    this.activeQuene[index] = {
      productId: product.id,
      id: firstVariant.id,
      quantity: 1,
      title: firstVariant.title,
      color: firstVariant.option1,
    };
    // add events
    this.filamentAddEvent(item, product, index);
    return item;
  }
  renderNormal(product, index) {
    const { title, handle, variants } = product;
    const firstVariant = variants[0];
    // create item
    const item = document.createElement("div");
    item.classList.add("rpv2-item");
    item.classList.add("rpv2-item-normal");
    if (index >= this.limit) {
      item.classList.add("hide");
    }
    item.setAttribute("data-index", index);
    item.innerHTML = `
      <input type="checkbox" class="rpv2-item__checkbox" disabled>
      <img class="rpv2-item__image" src="${firstVariant.featured_image}" />
      <div class="rpv2-item__content">
        <div class="rpv2-item__titleWrap">
          <div class="rpv2-item__title">
            <a href="/products/${handle}?variant=${
      firstVariant.id
    }" target="_blank">${title}</a>
          </div>
          <div class="rpv2-item__discountPrecent"></div>
        </div>
        <div class="rpv2-item__priceWrap">
          <div class="rpv2-item__price"></div>
          <div class="rpv2-item__discountPrice">${
            firstVariant.discount_price ? firstVariant.price : ""
          }</div>
        </div>
        <div class="rpv2-item__whatInThePack-normal" style="${
          product.witb ? "" : "display:none"
        }">
          <span>${product.witb}</span>
        </div>
        <div class="rpv2-item__content_selectAndBtnWrap">
            <div class="rpv2-item__content__selectWrap">
            <div class="rpv2-item__content__selectWrap__select" tabindex="-1">
              <div class="rpv2-item__content__selectWrap__select__item">
                <div class="rpv2-item__content__selectWrap__select__item__text">${
                  firstVariant.title
                }</div>
                <div class="rpv2-item__content__selectWrap__select__item__arrow">
                  <svg class="Icon Icon--select-arrow " role="presentation" viewBox="0 0 19 12">
                    <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
                  </svg>
                </div>
              </div>
            </div>
            <ul class="rpv2-item__content__selectWrap__select__ul"></ul>
          </div>
          <div class="rpv2-item__content__btnWrap">
            <div class="rpv2-item__content__btnWrap__QuantityWrap">
              <button class="rpv2-item__content__btnWrap__QuantityWrap__icon">
                <svg class="Icon Icon--custom-minus" role="presentation" width="0.8em" height="0.2em" viewBox="0 0 8 2" fill="none">
                  <path d="M0 1H4H8" stroke="#333333"></path>
                </svg>
              </button>
              <input type="number" class="rpv2-item__content__btnWrap__QuantityWrap__input" name="quantity" value="1" />
              <button class="rpv2-item__content__btnWrap__QuantityWrap__icon">
                <svg class="Icon Icon--custom-plus " role="presentation" width="0.8em" height="0.8em" viewBox="0 0 8 8" fill="none">
                  <path d="M0 4H4H8" stroke="#333333"></path>
                  <path d="M4 0L4 4L4 8" stroke="#333333"></path>
                </svg>
              </button>
            </div>
            <button class="rpv2-item__content__btnWrap__addBtn">${getTextByLocale(
              "add"
            )}</button>
          </div>
        </div>
        <div class="rpv2-item__content__selectedItemWrap">
          <div class="selectedItem-title">
            <div class="selectedItem-title-inner">
              <span>1</span>
              <span>${getTextByLocale("items_selected")}</span>
            </div>
          </div>
          <div class="selectedItem-content"></div>
        </div>
      </div>
    `;
    const discountPrecentDom = item.querySelector(
      ".rpv2-item__discountPrecent"
    );
    const discountPriceDom = item.querySelector(".rpv2-item__discountPrice");
    const priceDom = item.querySelector(".rpv2-item__price");
    if (
      firstVariant.discount_price &&
      firstVariant.discount_price_num !== firstVariant.price_num
    ) {
      discountPrecentDom.innerHTML = this.getDiscountPrecent(
        firstVariant.price_num,
        firstVariant.discount_price_num
      );
      priceDom.innerHTML = firstVariant.discount_price;
      discountPriceDom.innerHTML = firstVariant.price;
    } else {
      discountPrecentDom.innerHTML = "";
      priceDom.innerHTML = firstVariant.price;
      discountPriceDom.innerHTML = "";
    }
    // init activeQuene
    this.activeQuene[index] = {
      productId: product.id,
      id: firstVariant.id,
      quantity: 1,
      title: firstVariant.title,
    };
    // add events
    this.normalAddEvent(item, product, index);
    return item;
  }
  normalAddEvent(item, product, index) {
    const { variants } = product;
    this.checkboxEvent(item, index);
    this.selectWrapEvent(item);
    const selectUl = item.querySelector(
      ".rpv2-item__content__selectWrap__select__ul"
    );
    const items = this.genSelectLis(item, variants, index);
    selectUl.append(...items);
    this.quantityEvent(item, index);
    this.addItemEvent(item, index);
  }
  filamentAddEvent(item, product, index) {
    const { variants } = product;
    this.checkboxEvent(item, index);
    this.quantityEvent(item, index);
    this.addItemEvent(item, index, "filaments");
    this.selectWrapEvent(item);
    const filamentTab = item.querySelector(".rpv2-item__filamentTab");
    const selectUl = item.querySelector(
      ".rpv2-item__content__selectWrap__select__ul"
    );

    let spoolList = [];
    let refillList = [];
    if (product.type === "filaments_tpu") {
      spoolList = variants.filter(
        (variant) => variant.option2 === getTextByLocale("tpu_90a")
      );
      refillList = variants.filter(
        (variant) => variant.option2 === getTextByLocale("tpu_85a")
      );
    } else {
      spoolList = variants.filter(
        (variant) => variant.option2 === getTextByLocale("filament_with_spool")
      );
      refillList = variants.filter(
        (variant) => variant.option2 === getTextByLocale("refill")
      );
    }

    const spoolItems = this.genSelectLis(item, spoolList, index, "filaments");
    const refillItems = this.genSelectLis(item, refillList, index, "filaments");
    let activeList = spoolItems;
    if (spoolList.length > 0) {
      const spoolItem = document.createElement("div");
      spoolItem.classList.add("rpv2-item__filamentTab__item");
      spoolItem.classList.add("active");
      if (product.type === "filaments_tpu") {
        spoolItem.innerHTML = getTextByLocale("tpu_90a");
      } else {
        spoolItem.innerHTML = getTextByLocale("with_spool");
      }
      spoolItem.addEventListener("click", (e) => {
        if (spoolItem.classList.contains("active")) return;
        activeList = spoolItems.map((item, index) => {
          if (index === 0) {
            item.classList.add("active");
          } else {
            item.classList.remove("active");
          }
          return item;
        });
        const items = item.querySelectorAll(".rpv2-item__filamentTab__item");
        items.forEach((item) => {
          item.classList.remove("active");
        });
        spoolItem.classList.add("active");
        // change ul list
        selectUl.innerHTML = "";
        selectUl.append(...activeList);
        // reset base info
        this.resetBaseInfo(item, spoolList[0], "filaments");
        this.setActiveQuene(
          {
            id: spoolList[0].id,
            quantity: 1,
            title: spoolList[0].title,
            color: spoolList[0].option1,
          },
          index
        );
      });
      filamentTab.appendChild(spoolItem);
    }
    if (refillList.length > 0) {
      const refillItem = document.createElement("div");
      refillItem.classList.add("rpv2-item__filamentTab__item");
      if (product.type === "filaments_tpu") {
        refillItem.innerHTML = getTextByLocale("tpu_85a");
      } else {
        refillItem.innerHTML = getTextByLocale("refill");
      }
      refillItem.addEventListener("click", (e) => {
        if (refillItem.classList.contains("active")) return;
        activeList = refillItems.map((item, index) => {
          if (index === 0) {
            item.classList.add("active");
          } else {
            item.classList.remove("active");
          }
          return item;
        });
        const items = item.querySelectorAll(".rpv2-item__filamentTab__item");
        items.forEach((item) => {
          item.classList.remove("active");
        });
        refillItem.classList.add("active");
        // change ul list
        selectUl.innerHTML = "";
        selectUl.append(...activeList);
        // reset base info
        this.resetBaseInfo(item, refillList[0], "filaments");
        this.setActiveQuene(
          {
            id: refillList[0].id,
            quantity: 1,
            title: refillList[0].title,
            color: refillList[0].option1,
          },
          index
        );
      });
      if (spoolList.length === 0) {
        refillItem.classList.add("active");
        activeList = refillItems;
      }
      filamentTab.appendChild(refillItem);
    }
    selectUl.append(...activeList);
  }
  bundleAddEvent(item, product, index) {
    this.checkboxEvent(item, index);
    const dialogData = this.genDialogData(product);
    this.bundleOpenDialogEvent(item, index, dialogData);
  }
  checkboxEvent(item, index) {
    const checkbox = item.querySelector(".rpv2-item__checkbox");
    checkbox.addEventListener("change", (e) => {
      if (e.target.checked) {
        item.classList.add("selected");
        this.selectQuene[index].checked = true;
      } else {
        item.classList.remove("selected");
        this.selectQuene[index].checked = false;
      }
    });
  }
  quantityEvent(item, index) {
    const quantityInput = item.querySelector(
      ".rpv2-item__content__btnWrap__QuantityWrap__input"
    );
    const quantityMinus = item.querySelector(
      ".rpv2-item__content__btnWrap__QuantityWrap__icon:first-child"
    );
    const quantityPlus = item.querySelector(
      ".rpv2-item__content__btnWrap__QuantityWrap__icon:last-child"
    );
    quantityMinus.addEventListener("click", (e) => {
      let value = parseInt(quantityInput.value);
      if (value <= 1) return;
      quantityInput.value = value - 1;
      this.setActiveQuene({ quantity: value - 1 }, index);
    });
    quantityPlus.addEventListener("click", (e) => {
      let value = parseInt(quantityInput.value);
      quantityInput.value = value + 1;
      this.setActiveQuene({ quantity: value + 1 }, index);
    });
    quantityInput.addEventListener("change", (e) => {
      let quantityValue = 1;
      if (!quantityInput.value) {
        quantityValue = 1;
      } else {
        quantityValue = parseInt(quantityInput.value);
        if (quantityValue <= 0) {
          quantityValue = 1;
        }
      }
      quantityInput.value = quantityValue;
      this.setActiveQuene({ quantity: quantityValue }, index);
    });
  }
  addItemEvent(item, index, type) {
    const addBtn = item.querySelector(".rpv2-item__content__btnWrap__addBtn");
    addBtn.addEventListener("click", (e) => {
      const selectedWrap = item.querySelector(
        ".rpv2-item__content__selectedItemWrap"
      );
      const checkbox = item.querySelector(".rpv2-item__checkbox");
      const content = selectedWrap.querySelector(".selectedItem-content");
      if (
        !this.selectQuene[index] ||
        !this.selectQuene[index].checked ||
        this.selectQuene[index].lineItems.length === 0
      ) {
        console.log({ activeQuene: this.activeQuene, index });
        this.selectQuene[index] = {};
        this.selectQuene[index].checked = true;
        this.selectQuene[index].lineItems = [];
        this.selectQuene[index].lineItems.push({ ...this.activeQuene[index] });
        selectedWrap.style.display = "block";
        const selectedItemTitle = item.querySelector(
          ".selectedItem-title-inner span:first-child"
        );
        const sum = this.selectQuene[index].lineItems.reduce((sum, item) => {
          return sum + item.quantity;
        }, 0);
        selectedItemTitle.innerHTML = sum;

        // first add item, checkbox get checked
        checkbox.checked = true;
        checkbox.disabled = false;
        item.classList.add("selected");
        // add new item
        const selectItem = this.genSelectedItem(
          item,
          this.activeQuene[index],
          index,
          type
        );
        content.appendChild(selectItem);
      } else {
        const lineItems = this.selectQuene[index].lineItems;
        const activeQuene = this.activeQuene[index];
        const exist = lineItems.find((item) => item.id === activeQuene.id);
        if (exist) {
          exist.quantity += activeQuene.quantity;
          // just change quantity
          const selectItem = content.querySelector(
            `.selectedItem-content .selectedItem-content-item[data-id="${activeQuene.id}"]`
          );
          if (selectItem) {
            const quantityDom = selectItem.querySelector(
              ".selectedItem-content-item__quantity"
            );
            quantityDom.innerHTML = `X${exist.quantity}`;
          }
        } else {
          lineItems.push({ ...activeQuene });
          const selectItem = this.genSelectedItem(
            item,
            activeQuene,
            index,
            type
          );
          content.appendChild(selectItem);
        }
        this.selectQuene[index].lineItems = lineItems;
        // set how many items selected
        const selectedItemTitle = item.querySelector(
          ".selectedItem-title-inner span:first-child"
        );
        const sum = lineItems.reduce((sum, item) => {
          return sum + item.quantity;
        }, 0);
        selectedItemTitle.innerHTML = sum;
      }
    });
  }
  isFilamentBundleItem(title) {
    // shopify bundle 只能以 title 的结尾是不是 (color) 来区分
    return title.endsWith("(" + getTextByLocale("color") + ")");
  }
  genDialogData(product) {
    const data = {
      title: product.title,
      // price: product.price_varies ? product.from_price : product.price,
      // discountPrice: product.discount_price,
      // precent: this.getDiscountPrecent(
      //   product.price_num,
      //   product.discount_price_num
      // ),
      options: [],
      variants: product.variants,
    };
    product.options.forEach((option, index) => {
      const optionName = `option${index + 1}`;
      const colors = product.variants
        .map((variant) => variant[optionName])
        .filter((value, index, self) => self.indexOf(value) === index);
      data.options.push({
        title: option,
        colors: colors,
        isFilamentItem: this.isFilamentBundleItem(option),
      });
    });
    return data;
  }
  genBundleFilamentItem(option, idx, activeQuene, variants) {
    const optionItem = document.createElement("div");
    optionItem.classList.add("rpv2-dialog__content__optionsWrap__item");
    // title 去掉括号里的内容
    const title = option.title.replace(/\([^)]*\)/g, "");
    optionItem.innerHTML = `
      <div class="rpv2-dialog__content__optionsWrap__item__title">${title}</div>
      <div class="rpv2-dialog__content__optionsWrap__item__option">
        <span>${getTextByLocale("color")}: </span>
        <span class="rpv2-dialog__content__optionsWrap__item__option__value">${
          activeQuene.options[idx]
        }</span>
      </div>
      <ul class="rpv2-dialog__content__optionsWrap__item__ul"></ul>
    `;
    const ul = optionItem.querySelector("ul");
    option.colors.forEach((color) => {
      const li = document.createElement("li");
      li.classList.add("rpv2-dialog__content__optionsWrap__item__ul__li");
      if (color === activeQuene.options[idx]) {
        li.classList.add("active");
      }
      const isDisabled = this.calculateDisabled(variants, idx, color);
      if (isDisabled) {
        li.classList.add("disabled");
      }
      li.innerHTML = `
        <div class="rpv2-dialog__content__optionsWrap__item__ul__li__colorDiv" style="background: ${this.getColor(
          color
        )}"></div>
      `;
      li.setAttribute("data-color", color);
      li.addEventListener("click", (e) => {
        if (li.classList.contains("disabled")) return;
        const lis = optionItem.querySelectorAll(
          ".rpv2-dialog__content__optionsWrap__item__ul__li"
        );
        lis.forEach((li) => {
          li.classList.remove("active");
        });
        li.classList.add("active");
        activeQuene.options[idx] = color;
        const nowVariant = this.getVariantByOptions(
          variants,
          activeQuene.options
        );
        activeQuene.id = nowVariant.id;
        activeQuene.title = nowVariant.title;
        activeQuene.price = nowVariant.price;
        activeQuene.discountPrice = nowVariant.discount_price;
        // change option title
        const optionValue = optionItem.querySelector(
          ".rpv2-dialog__content__optionsWrap__item__option__value"
        );
        optionValue.innerHTML = color;
        // change price
        const priceDom = document.querySelector(
          ".rpv2-dialog__content__priceWrap .rpv2-dialog__content__priceWrap__price"
        );
        const discountPriceDom = document.querySelector(
          ".rpv2-dialog__content__priceWrap .rpv2-dialog__content__priceWrap__discountPrice"
        );
        priceDom.innerHTML = activeQuene.discountPrice || activeQuene.price;
        discountPriceDom.innerHTML = activeQuene.discountPrice
          ? activeQuene.price
          : "";
      });
      ul.appendChild(li);
    });
    return optionItem;
  }
  genBundleFilamentItemSelectUl(
    option,
    idx,
    activeQuene,
    variants,
    triggerElement
  ) {
    const presentation = document.createElement("div");
    presentation.setAttribute("role", "presentation");
    presentation.classList.add(
      "rpv2-dialog__content__optionsWrap__item__presentation"
    );
    const maskItem = document.createElement("div");
    maskItem.classList.add("rpv2-dialog__content__optionsWrap__item__mask");
    const ulWrap = document.createElement("div");
    ulWrap.classList.add("rpv2-dialog__content__optionsWrap__item__ulWrap");
    ulWrap.innerHTML = `
      <div class="rpv2-dialog__content__optionsWrap__item__ulInner">
        <ul class="rpv2-dialog__content__optionsWrap__item__selectUl">
          ${option.colors
            .map((color) => {
              return `
              <li class="rpv2-dialog__content__optionsWrap__item__ul__li ${
                color === activeQuene.options[idx] ? "active" : ""
              } ${
                this.calculateDisabled(variants, idx, color) ? "disabled" : ""
              }" data-color="${color}">
                <div class="rpv2-dialog__content__optionsWrap__item__ul__li__text">${color}</div>
              </li>
            `;
            })
            .join("")}
        </ul>
      </div>
    `;
    // 定位
    const rect = triggerElement.getBoundingClientRect();
    const top = rect.top;
    const left = rect.left;
    ulWrap.style.top = `${top + rect.height}px`;
    ulWrap.style.left = `${left}px`;
    ulWrap.style.width = `${rect.width}px`;

    // lis add click event
    const ul = ulWrap.querySelector(
      ".rpv2-dialog__content__optionsWrap__item__selectUl"
    );
    const lis = ul.querySelectorAll("li");
    const input = triggerElement.querySelector(
      ".rpv2-dialog__content__optionsWrap__item__inputWrap__input"
    );
    lis.forEach((li, index) => {
      const color = option.colors[index];
      li.addEventListener("click", (e) => {
        if (li.classList.contains("disabled")) {
          // close select ul
          this.destoryBundleFilamentItemSelectUl();
          return;
        }
        lis.forEach((li) => {
          li.classList.remove("active");
        });
        li.classList.add("active");
        activeQuene.options[idx] = color;
        const nowVariant = this.getVariantByOptions(
          variants,
          activeQuene.options
        );
        activeQuene.id = nowVariant.id;
        activeQuene.title = nowVariant.title;
        activeQuene.price = nowVariant.price;
        activeQuene.discountPrice = nowVariant.discount_price;

        // close select ul
        this.destoryBundleFilamentItemSelectUl();
        // change input value
        input.innerHTML = color;
        // change price
        const priceDom = document.querySelector(
          ".rpv2-dialog__content__priceWrap .rpv2-dialog__content__priceWrap__price"
        );
        const discountPriceDom = document.querySelector(
          ".rpv2-dialog__content__priceWrap .rpv2-dialog__content__priceWrap__discountPrice"
        );
        priceDom.innerHTML = activeQuene.discountPrice || activeQuene.price;
        discountPriceDom.innerHTML = activeQuene.discountPrice
          ? activeQuene.price
          : "";
      });
    });

    // click outside event
    maskItem.addEventListener("click", (e) => {
      this.destoryBundleFilamentItemSelectUl();
    });
    presentation.appendChild(maskItem);
    presentation.appendChild(ulWrap);
    document.body.appendChild(presentation);
    setTimeout(() => {
      presentation.classList.add("active");
    }, 100);
  }
  destoryBundleFilamentItemSelectUl() {
    const presentations = document.querySelectorAll(
      ".rpv2-dialog__content__optionsWrap__item__presentation"
    );
    presentations.forEach((presentation) => {
      presentation.classList.remove("active");
      setTimeout(() => {
        document.body.removeChild(presentation);
      }, 300);
    });
  }
  genBundleNormalItem(option, idx, activeQuene, variants) {
    const optionItem = document.createElement("div");
    optionItem.classList.add("rpv2-dialog__content__optionsWrap__item");
    // title 去掉括号里的内容
    const title = option.title.replace(/\([^)]*\)/g, "");
    optionItem.innerHTML = `
      <div class="rpv2-dialog__content__optionsWrap__item__title" style="margin-bottom: 10px;">${title}</div>
      <div class="rpv2-dialog__content__optionsWrap__item__selectWrap">
        <div class="rpv2-dialog__content__optionsWrap__item__inputWrap" tabindex="-1">
          <div class="rpv2-dialog__content__optionsWrap__item__inputWrap__input">${activeQuene.options[idx]}</div>
          <div class="rpv2-dialog__content__optionsWrap__item__inputWrap__arrow">
            <svg class="Icon Icon--select-arrow " role="presentation" viewBox="0 0 19 12">
              <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
            </svg>
          </div>
        </div>
      </div>
    `;
    // add event for select
    const selectWrap = optionItem.querySelector(
      ".rpv2-dialog__content__optionsWrap__item__selectWrap"
    );
    const inputWrap = selectWrap.querySelector(
      ".rpv2-dialog__content__optionsWrap__item__inputWrap"
    );
    inputWrap.addEventListener("click", (e) => {
      selectWrap.classList.toggle("focused");
      this.genBundleFilamentItemSelectUl(
        option,
        idx,
        activeQuene,
        variants,
        selectWrap
      );
    });
    inputWrap.addEventListener("blur", (e) => {
      selectWrap.classList.remove("focused");
    });
    return optionItem;
  }
  bundleOpenDialogEvent(item, index, data) {
    console.log({ data });
    const selectBtn = item.querySelector(
      ".rpv2-item__content__btnWrap__selectBtn"
    );
    selectBtn.addEventListener("click", (e) => {
      const { title, price, discountPrice, precent, options, variants } = data;
      const optionsTitleArr = options.map((option) =>
        option.title.replace(/\([^)]*\)/g, "")
      );
      const activeQuene = this.activeQuene[index];
      console.log({ activeQuene });
      const dialog = document.createElement("div");
      dialog.classList.add("rpv2-dialog");
      dialog.innerHTML = `
        <div class="rpv2-dialog__content">
          <div class="rpv2-dialog__content__top">
            <div class="rpv2-dialog__content__titleWrap">
              <div class="rpv2-dialog__content__title">${title}</div>
            </div>
            <div class="rpv2-dialog__content__priceWrap">
              <div class="rpv2-dialog__content__priceWrap__price">${
                activeQuene.discountPrice || activeQuene.price
              }</div> 
              <div class="rpv2-dialog__content__priceWrap__discountPrice">${
                activeQuene.discountPrice ? activeQuene.price : ""
              }</div>
            </div>
          </div>
          <div class="rpv2-dialog__content__optionsWrap"></div>
          <div class="rpv2-dialog__content__btnWrap">
            <button class="rpv2-dialog__content__btnWrap__closeBtn">${getTextByLocale(
              "close"
            )}</button>
            <button class="rpv2-dialog__content__btnWrap__addBtn">${getTextByLocale(
              "add"
            )}</button>
          </div>
        </div>
      `;
      const optionsWrap = dialog.querySelector(
        ".rpv2-dialog__content__optionsWrap"
      );
      options.forEach((option, idx) => {
        let optionItem;
        if (option.isFilamentItem) {
          optionItem = this.genBundleFilamentItem(
            option,
            idx,
            activeQuene,
            variants
          );
        } else {
          optionItem = this.genBundleNormalItem(
            option,
            idx,
            activeQuene,
            variants
          );
        }
        optionsWrap.appendChild(optionItem);
      });
      document.body.appendChild(dialog);
      // body add overflow hidden
      document.body.style.overflow = "hidden";
      // close button event
      const closeBtn = dialog.querySelector(
        ".rpv2-dialog__content__btnWrap__closeBtn"
      );
      closeBtn.addEventListener("click", (e) => {
        document.body.removeChild(dialog);
        document.body.style.overflow = "auto";
      });
      // add button event
      const addBtn = dialog.querySelector(
        ".rpv2-dialog__content__btnWrap__addBtn"
      );
      addBtn.addEventListener("click", (e) => {
        const selectedWrap = item.querySelector(
          ".rpv2-item__content__selectedItemWrap"
        );
        const checkbox = item.querySelector(".rpv2-item__checkbox");
        const content = selectedWrap.querySelector(".selectedItem-content");
        if (
          !this.selectQuene[index] ||
          !this.selectQuene[index].checked ||
          this.selectQuene[index].lineItems.length === 0
        ) {
          this.selectQuene[index] = {};
          this.selectQuene[index].checked = true;
          this.selectQuene[index].lineItems = [];
          this.selectQuene[index].lineItems.push({
            ...this.activeQuene[index],
          });
          selectedWrap.style.display = "block";
          const selectedItemTitle = item.querySelector(
            ".selectedItem-title-inner span:first-child"
          );
          const sum = this.selectQuene[index].lineItems.reduce((sum, item) => {
            return sum + item.quantity;
          }, 0);
          selectedItemTitle.innerHTML = sum;
          // first add item, checkbox get checked
          checkbox.checked = true;
          checkbox.disabled = false;
          item.classList.add("selected");
          // add new item
          const selectItem = this.genSelectedItem(
            item,
            this.activeQuene[index],
            index,
            "starter_pack",
            optionsTitleArr
          );
          content.appendChild(selectItem);
        } else {
          const lineItems = this.selectQuene[index].lineItems;
          const activeQuene = this.activeQuene[index];
          const exist = lineItems.find((item) => item.id === activeQuene.id);
          if (exist) {
            exist.quantity += activeQuene.quantity;
            // just change quantity
            const selectItem = item.querySelector(
              `.selectedItem-content .selectedItem-content-item[data-id="${activeQuene.id}"]`
            );
            if (selectItem) {
              const quantityDom = selectItem.querySelector(
                ".selectedItem-content-item__quantity"
              );
              quantityDom.innerHTML = `X${exist.quantity}`;
            }
          } else {
            lineItems.push({ ...activeQuene });
            const selectItem = this.genSelectedItem(
              item,
              activeQuene,
              index,
              "starter_pack",
              optionsTitleArr
            );
            const content = item.querySelector(".selectedItem-content");
            content.appendChild(selectItem);
          }
          this.selectQuene[index].lineItems = lineItems;
          // set how many items selected
          const selectedItemTitle = item.querySelector(
            ".selectedItem-title-inner span:first-child"
          );
          const sum = lineItems.reduce((sum, item) => {
            return sum + item.quantity;
          }, 0);
          selectedItemTitle.innerHTML = sum;
        }
        document.body.removeChild(dialog);
        document.body.style.overflow = "auto";
        // select colors button change to add one more
        selectBtn.innerHTML = getTextByLocale("add_one_more");
      });
      // click outside close dialog
      dialog.addEventListener("click", (e) => {
        if (e.target === dialog) {
          document.body.removeChild(dialog);
          document.body.style.overflow = "auto";
        }
      });
    });
  }
  selectWrapEvent(item) {
    const selectWrap = item.querySelector(".rpv2-item__content__selectWrap");
    const select = item.querySelector(
      ".rpv2-item__content__selectWrap__select"
    );
    select.addEventListener("click", (e) => {
      selectWrap.classList.toggle("focused");
    });
    select.addEventListener("blur", (e) => {
      selectWrap.classList.remove("focused");
    });
  }
  genSelectLis(item, variants, index, type) {
    const items = [];
    variants.forEach((variant, idx) => {
      const selectItem = document.createElement("li");
      selectItem.classList.add("rpv2-item__content__selectWrap__select__item");
      selectItem.classList.add("ulItem");
      if (idx === 0) {
        selectItem.classList.add("active");
      }
      if (type === "filaments") {
        const selectColorBox = document.createElement("div");
        selectColorBox.classList.add(
          "rpv2-item__content__selectWrap__select__item__filamentBox"
        );
        selectColorBox.style.background = this.getColor(variant.option1);
        selectItem.appendChild(selectColorBox);
      }
      const selectText = document.createElement("div");
      selectText.classList.add(
        "rpv2-item__content__selectWrap__select__item__text"
      );
      if (type === "filaments") {
        selectText.innerHTML = variant.option1;
      } else {
        selectText.innerHTML = variant.title;
      }
      selectItem.appendChild(selectText);
      selectItem.addEventListener("click", (e) => {
        const selectItems = item.querySelectorAll(
          ".rpv2-item__content__selectWrap__select__item.ulItem"
        );
        selectItems.forEach((item) => {
          item.classList.remove("active");
        });
        selectItem.classList.add("active");
        this.resetBaseInfo(item, variant, type);
        this.setActiveQuene(
          {
            id: variant.id,
            quantity: 1,
            title: variant.title,
            color: variant.option1,
          },
          index
        );
      });
      items.push(selectItem);
    });
    return items;
  }
  resetBaseInfo(item, variant, type) {
    const selectWrap = item.querySelector(".rpv2-item__content__selectWrap");
    const selectColorBox = item.querySelector(
      ".rpv2-item__content__selectWrap__select .rpv2-item__content__selectWrap__select__item__filamentBox"
    );
    const selectText = item.querySelector(
      ".rpv2-item__content__selectWrap__select .rpv2-item__content__selectWrap__select__item__text"
    );
    const image = item.querySelector(".rpv2-item__image");
    const title = item.querySelector(".rpv2-item__title a");
    const price = item.querySelector(".rpv2-item__price");
    const discountPrice = item.querySelector(".rpv2-item__discountPrice");
    const discountPrecent = item.querySelector(".rpv2-item__discountPrecent");
    const weight = item.querySelector(".rpv2-item__weight");
    const quantityInput = item.querySelector(
      ".rpv2-item__content__btnWrap__QuantityWrap__input"
    );
    // wrap blur
    selectWrap.classList.remove("focused");
    // change select color, variant title
    selectText.innerHTML = variant.title;
    if (type === "filaments") {
      selectColorBox.style.background = this.getColor(variant.option1);
      selectText.innerHTML = variant.option1;
    }
    // change image, title, price
    image.src = variant.featured_image;
    // 替换 variant id
    title.href = title.href.replace(/\?variant=\d+/, `?variant=${variant.id}`);
    if (
      variant.discount_price &&
      variant.discount_price_num !== variant.price_num
    ) {
      price.innerHTML = variant.discount_price;
      discountPrice.innerHTML = variant.price;
      // discountPrice.style.display = "block";
      discountPrecent.innerHTML = this.getDiscountPrecent(
        variant.price_num,
        variant.discount_price_num
      );
      discountPrecent.style.display = "block";
    } else {
      price.innerHTML = variant.price;
      discountPrice.innerHTML = "";
      discountPrecent.innerHTML = "";
    }
    if (type === "filaments") {
      weight.innerHTML = variant.option3;
    }
    quantityInput.value = 1;
  }
  getDiscountPrecent(price, compareAtPrice) {
    if (!compareAtPrice) return "";
    return `${Math.round((1 - compareAtPrice / price) * 100)}% off`;
  }
  getColor(label) {
    if (!label) return "#FFFFFF";
    const parts = label.split("(");
    // 防止颜色的规格不规范，导致整个随机购无法展示
    const part2 = parts[1] ? parts[1] : "";
    const code_part = part2.split(")");
    const trueValue = code_part[0];
    const prefix = "HEX Code ";
    if (trueValue.startsWith(prefix)) {
      const colorValue = trueValue.substr(prefix.length, trueValue.length);
      return colorValue;
    } else {
      const colorValue = colorCodes[trueValue] || "#FFFFFF"; // 位置的颜色，默认白色
      const splitValue = colorValue.split(";");
      if (splitValue.length > 1) {
        return `linear-gradient(0deg, ${splitValue[0]}, ${splitValue[1]})`;
      }
      return colorValue;
    }
  }
  setActiveQuene(item, index) {
    this.activeQuene[index] = { ...this.activeQuene[index], ...item };
  }
  setSelectQuene(item) {}
  getSelectQuene() {
    return this.selectQuene;
  }
  genSelectedItem(item, selectItem, index, type, optionsTitleArr) {
    const selectedWrap = item.querySelector(
      ".rpv2-item__content__selectedItemWrap"
    );
    const checkbox = item.querySelector(".rpv2-item__checkbox");
    const selectedItem = document.createElement("div");
    selectedItem.classList.add("selectedItem-content-item");
    selectedItem.setAttribute("data-id", selectItem.id);
    let title = selectItem.title;
    // type === starter_pack title需要再处理
    if (type === "starter_pack") {
      const titleArr = title.split(" / ");
      // 将 optionsTitleArr 与 titleArr 使用 ' - '拼接
      title = titleArr
        .map((item, index) => {
          return `${optionsTitleArr[index]} - ${item}`;
        })
        .join(" / ");
    }
    selectedItem.innerHTML = `
      <div class="selectedItem-content-item__title">${title}</div>
      <div class="selectedItem-content-item__quantity">X${selectItem.quantity}</div>
      <div class="selectedItem-content-item__delete">
        <svg width="1.1em" height="1.4em" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="Exclude" fill-rule="evenodd" clip-rule="evenodd" d="M8.72327 13.6666C9.55807 13.6666 10.2411 12.9663 10.2411 12.1104L10.2411 3.44554L1.13419 3.44554L1.13419 12.1104C1.13419 12.9663 1.81721 13.6666 2.65201 13.6666L8.72327 13.6666ZM1.04195 1.11132C0.673763 1.11132 0.375286 1.4098 0.375286 1.77799L0.375286 2.0008C0.375286 2.36899 0.673763 2.66747 1.04195 2.66747L10.3333 2.66747C10.7015 2.66747 11 2.36899 11 2.0008L11 1.77799C11 1.4098 10.7015 1.11132 10.3333 1.11132L8.34382 1.11132L7.58491 0.333252L3.79037 0.333251L3.03146 1.11132L1.04195 1.11132ZM7.68969 5.80805C7.68969 5.5971 7.8607 5.42609 8.07165 5.42609C8.2826 5.42609 8.45361 5.5971 8.45361 5.80805L8.45361 11.5799C8.45361 11.7909 8.2826 11.9619 8.07165 11.9619C7.8607 11.9619 7.68969 11.7909 7.68969 11.5799L7.68969 5.80805ZM5.73746 5.42609C5.52651 5.42609 5.35549 5.5971 5.35549 5.80805L5.35549 11.5799C5.35549 11.7909 5.5265 11.9619 5.73746 11.9619C5.94841 11.9619 6.11942 11.7909 6.11942 11.5799L6.11942 5.80805C6.11942 5.5971 5.94841 5.42609 5.73746 5.42609ZM3.02122 5.80805C3.02122 5.5971 3.19224 5.42609 3.40319 5.42609C3.61414 5.42609 3.78515 5.5971 3.78515 5.80805L3.78515 11.5799C3.78515 11.7909 3.61414 11.9619 3.40319 11.9619C3.19224 11.9619 3.02122 11.7909 3.02122 11.5799L3.02122 5.80805Z" fill="currentColor"/>
        </svg>
      </div>
    `;
    if (type === "filaments") {
      const colorBox = document.createElement("div");
      colorBox.classList.add("selectedItem-content-item__colorBox");
      colorBox.style.background = this.getColor(selectItem.color);
      selectedItem.prepend(colorBox);
    }
    // delete icon add click event
    const deleteIcon = selectedItem.querySelector(
      ".selectedItem-content-item__delete"
    );
    deleteIcon.onclick = (e) => {
      const lineItems = this.selectQuene[index].lineItems;
      const idx = lineItems.findIndex((item) => item.id === selectItem.id);
      lineItems.splice(idx, 1);
      this.selectQuene[index].lineItems = lineItems;
      selectedItem.remove();
      // set how many items selected
      const selectedItemTitle = item.querySelector(
        ".selectedItem-title-inner span:first-child"
      );
      const sum = lineItems.reduce((sum, item) => {
        return sum + item.quantity;
      }, 0);
      selectedItemTitle.innerHTML = sum;
      if (lineItems.length === 0) {
        // this.selectQuene.splice(index, 1);
        this.selectQuene[index] = { checked: false, lineItems: [] };
        selectedWrap.style.display = "none";
        checkbox.checked = false;
        checkbox.disabled = true;
        item.classList.remove("selected");
        if (type === "starter_pack") {
          const selectBtn = item.querySelector(
            ".rpv2-item__content__btnWrap__selectBtn"
          );
          selectBtn.innerHTML = getTextByLocale("select_items");
        }
      }
    };
    return selectedItem;
  }
  genShowMore() {
    if (this.products.length <= this.limit) return null;
    const showMore = document.createElement("div");
    showMore.classList.add("rpv2-showMore");
    showMore.innerHTML = `
      <span class="rpv2-showMore__content">${getTextByLocale(
        "show_more"
      )}</span>
      <div class="rpv2-showMore__icon">
        <svg class="Icon Icon--select-arrow " role="presentation" viewBox="0 0 19 12">
          <polyline fill="none" stroke="currentColor" points="17 2 9.5 10 2 2" fill-rule="evenodd" stroke-width="2" stroke-linecap="square"></polyline>
        </svg>
      </div>
    `;
    showMore.addEventListener("click", (e) => {
      this.showMore = !this.showMore;
      showMore.classList.toggle("open");
      const content = showMore.querySelector(".rpv2-showMore__content");
      content.innerHTML = this.showMore
        ? getTextByLocale("hide")
        : getTextByLocale("show_more");
      const items = this.dom.querySelectorAll(".rpv2-item");
      items.forEach((item, index) => {
        if (index >= this.limit) {
          item.classList.toggle("hide");
        }
      });
    });
    return showMore;
  }
  calculateDisabled(variants, idx, color) {
    // 想太多。。。
    // let preOptions = [];
    // if (idx === 0) {
    //   preOptions.push(color);
    // } else {
    //   preOptions = options.slice(0, idx);
    //   preOptions.push(color);
    // }
    // const preVariant = variants.find((variant) => {
    //   const flag = preOptions.every((option, idx) => {
    //     return variant[`option${idx + 1}`] === option;
    //   });
    //   return flag && variant.available;
    // });
    // return preVariant ? false : true;
    const variant = variants.find((variant) => {
      return variant[`option${idx + 1}`] === color && variant.available;
    });
    return variant ? false : true;
  }
  getVariantByOptions(variants, options) {
    return variants.find((variant) => {
      const flag = options.every((option, idx) => {
        return variant[`option${idx + 1}`] === option;
      });
      return flag;
    });
  }
}

(function () {
  window.prv2 = function (products, limit) {
    return new RecommendProducts(products, limit);
  };
  window.onbeforeunload = function () {
    window.prev2 = null;
  };
})();

// TODO: bundle item
// TODO: web 端样式
